import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import { adminGetAllSubject, adminGetAllSubjects } from '../../redux/action/adminAction'
import AdminHomeHelper from '../../Components/AdminHomeHelper'
import classnames from 'classnames'
import Loading from '../../Components/Loading';

const AdminGetAllSubjects = () => {
    const store = useSelector((store) => store)
    const dispatch = useDispatch()
    const [department, setDepartment] = useState('')
    const [year, setYear] = useState('')
    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const history = useHistory()


    const formHandler = (e) => {
        e.preventDefault()
        setIsLoading(true)
        dispatch(adminGetAllSubject({ department, year }))

    }
    useEffect(() => {
        dispatch(adminGetAllSubjects({}));
    }, []);
    useEffect(() => {
        if (store.admin.allSubject.length !== 0) {
            setIsLoading(false)
        }

    }, [store.admin.allSubject.length])
    const isDataAvailable = store.admin.allSubject && store.admin.allSubject.length > 0;
    return (
        <div>
            <div>
                {store.admin.isAuthenticated ? <>
                    <div className="container-fluid p-0">
                <div className="d-flex">
                    <div className="print-helper">
                        <AdminHomeHelper />
                    </div>
                    <div className="mx-1 w-100 ">
                        <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h3> <img src="/logo192.png" width={'50px'} alt="" /> ACADEMIC'S</h3>
                        <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                        </div>
                            <div className="col d-flex align-items-center justify-content-between">
                                <form noValidate className='d-flex align-items-center justify-content-start' onSubmit={formHandler}>
                                    <div className="form-group mx-2">
                                        <label htmlFor="departmentId">Department</label>
                                        <select onChange={(e) => setDepartment(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.department
                                            })} id="departmentId">
                                            <option>Select</option>
                                            <option value="ECE">ECE</option>
                                            <option value="CSE">CSE</option>
                                            <option value="EEE">EEE</option>
                                            <option value="AIDS">AIDS</option>
                                            <option value="MECH">MECH</option>
                                            <option value="CIVIL">CIVIL</option>
                                                <option value="BIO">BIO</option>
                                                <option value="AGRI">AGRI</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                                        </select>
                                        {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                                    </div>
                                    <div className="form-group mx-2">
                                        <label htmlFor="yearId">Year</label>
                                        <select onChange={(e) => setYear(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.year
                                            })} id="yearId">
                                            <option>Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                        </select>
                                        {error.year && (<div className="invalid-feedback">{error.year}</div>)}
                                    </div>
                                    <div className='mt-3'>
                                {!isLoading && <button type="submit" className="btn btn-info btn-block  ">Search</button>}
                                        {
                                            isLoading && <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        }
                                </div>
                                </form>
                                <button className='btn btn-success '> <Link to="/admin/addSubject" className='text-light'> <img src="/image/add.svg" alt="" /> Add Subject</Link></button>
                            </div>
                            {isDataAvailable ? (
                            <div className="col">

                                {store.admin.allSubject.length !== 0 && <table className="mt-3 table table-responsive table table-bordered table-striped-columns">
                                    <thead>
                                        <tr className='bg-secondary text-light'>
                                            <th scope="col" width="10%">S.No</th>
                                            <th scope="col" width="20%">Subject Code</th>
                                            <th scope="col" width="10%">Department</th>
                                            <th scope="col" width="10%">Year</th>
                                            <th scope="col" width="10%">Semester</th>
                                            <th scope="col" width="30%">Subject Name</th>
                                            <th scope="col" width="10%">Type</th>
                                            <th scope="col" width="10%">Credit</th>
                                            <th scope="col"  width="20%">Notes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            store.admin.allSubject.map((res, index) =>
                                                <tr key={index}>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>{res.subjectCode}</td>
                                                    <td>{res.department}</td>
                                                    <td>{res.year}</td>
                                                    <td>{res.semester}</td>
                                                    <td>{res.subjectName}</td>
                                                    <td>Theory</td>
                                                    <td>4</td>
                                                    <td><button className='btn btn-success'>Upload</button></td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>}

                            </div>
                            ) : (
                             <Loading />
                            )}
                            </div>
                        </div>
                    </div>
                </> : (history.push('/'))}
            </div>
            
        </div>
    )
}

export default AdminGetAllSubjects
